import React from 'react';
import { TextInput } from '@mantine/core';
import PropTypes from 'prop-types';
import AppStack from '../../common/AppStack';

const StoreCreationNameStep = ({
  loading,
  createOptions,
  formState,
  setFormState,
  submitting
}) => {
  const { storeType } = formState;

  return (
    <AppStack style={{ gap: 20 }}>
      <TextInput
        disabled={submitting}
        onChange={(e) =>
          setFormState({
            ...formState,
            storeSettings: {
              ...formState.storeSettings,
              name: e.currentTarget.value
            }
          })
        }
        placeholder="Store name"
        required
        value={formState.storeSettings.name || ''}
      />
    </AppStack>
  );
};

StoreCreationNameStep.propTypes = {
  createOptions: PropTypes.object,
  formState: PropTypes.object,
  loading: PropTypes.bool,
  setFormState: PropTypes.func,
  submitting: PropTypes.bool
};

export default StoreCreationNameStep;
